import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-sign-out",
  "use": "icon-si-glyph-sign-out-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-sign-out\" id=\"icon-si-glyph-sign-out\"><title>913</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><g><path d=\"M8.99511719,4.91699982 L10.9866943,4.91699982 L10.9866943,-1.83121302e-07 L0,-1.59161573e-11 L8.026,2.666 L8.026,14.917 L0.321,13 L0.106,13.829 L8.99511719,15.9820557 L8.99511719,12.8970557 L10.9866943,12.9149998 L10.9866943,9.04199982 L8.99511719,9.04199982 L8.99511719,4.91699982 Z\" class=\"si-glyph-fill\" /><path d=\"M14.904,7 L12.034,4.068 L12.034,6.055 L10,6.055 L10,7.971 L12.034,7.971 L12.034,10.033 L14.904,7 Z\" class=\"si-glyph-fill\" /></g><rect x=\"6\" y=\"8\" width=\"0.958\" height=\"0.916\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-sign-out.svg
// module id = z2b/
// module chunks = 62